<template>
  <v-container
    class="newsletter"
    fluid
  >
    <section class="newsletter__section">
      <Heading
        font-color="#ffffff"
        font-size="36px"
        line-height="50px"
        class="newsletter__title"
      >
        Quer saber sobre os próximos leilões?
      </Heading>
      <Heading
        font-color="#ffffff"
        font-size="24px"
        line-height="50px"
        level="2"
        font-weight="700"
        class="newsletter__subtitle"
      >
        Receba a agenda dos nossos próximos leilões diariamente.
      </Heading>
    </section>
    <Button
      font-color="#EE396C"
      font-size="17px"
      background-color="#ffffff"
      padding="15px 55px"
      line-height="0px"
      @click="dialog = true"
    >
      Cadastrar
    </Button>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Quer saber sobre os próximos leilões?</span>
        </v-card-title>
        <v-card-subtitle>
          <span class="subtitle-1">Receba a agenda dos nossos próximos leilões diariamente. </span>
        </v-card-subtitle>
        <v-card-text>
          <v-container
            class="pa-0 ma-0"
            fluid
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Nome*"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Email*"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="align-center justify-center">
          <v-btn
            color="#CCC"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="accent"
            elevation="0"
            @click="dialog = false"
          >
            Realizar Cadastro
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';
import Button from '@/components/Button/Button.vue';

export default {
  name: 'Newsletter',
  components: { Heading, Button },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.newsletter {
  background: linear-gradient(317.33deg, #292667 -64.75%, #ee396c 78.06%);
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: $md) {
    align-items: flex-start;
  }

  &__title {
    @media (max-width: $md) {
      font-size: 26px !important;
      line-height: 30px !important;
    }
  }
  &__subtitle {
    @media (max-width: $md) {
      font-size: 16px !important;
      line-height: 20px !important;
      margin-top: 10px;
    }
  }

  @media (max-width: $md) {
    flex-direction: column;
  }

  &__section {
    margin-right: 160px;
    @media (max-width: $md) {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
}
</style>
